import React, { useState } from 'react';
import styled from 'styled-components';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import dayjs from 'dayjs';

const Wrapper = styled.div`
  width: 100%;
  margin-top: 20px;

  .MuiInputBase-root {
    height: 50px;
    border: 1px solid #dddddd;
    border-radius: 0px;
    padding: 15px;
    margin-top: 25px;
    font-family: Akkurat;
    font-size: 16px;
    font-weight: 400;
    cursor: pointer;

    &:hover {
      border-color: #000;
    }

    &.Mui-focused {
      border-color: #000000;
    }

    fieldset {
      border: none !important;
    }
  }

  .MuiInputLabel-root {
    top: -5px;
    font-size: 14px;
    line-height: 24px;
    font-weight: 400;
    font-family: Akkurat_Bold;
    color: #292d32;
    transform: none !important;
    width: 100%;
  }

  .MuiInputLabel-root.Mui-focused {
    color: #1e1e1e;
  }

  .MuiInputBase-input {
    padding: 0 !important;
    font-size: 16px !important;
    font-family: Akkurat !important;
    font-weight: 400 !important;
    line-height: 16px !important;
    color: #000000 !important;
    cursor: pointer;

    &::placeholder {
      color: #7d7d7d;
      opacity: 1;
    }
  }

  .MuiSvgIcon-root {
    color: #000;
    width: 22px;
    height: 22px;
    cursor: pointer;
  }
`;

const TimePickerInput = ({
  label,
  value,
  onChange,
  disabled,
  minTime,
  maxTime,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <Wrapper>
      <TimePicker
        ampm={true}
        label={label}
        value={value ? dayjs(`2024-01-01 ${value}`) : null}
        onChange={(newValue) => {
          if (!newValue) {
            onChange('');
            return;
          }

          onChange(dayjs(newValue).format('HH:mm'));
        }}
        disabled={disabled}
        minTime={minTime ? dayjs(`2024-01-01 ${minTime}`) : undefined}
        maxTime={maxTime ? dayjs(`2024-01-01 ${maxTime}`) : undefined}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        slotProps={{
          textField: {
            fullWidth: true,
            variant: 'outlined',
            placeholder: 'HH:MM',
            InputLabelProps: {
              shrink: true,
            },
            onClick: () => setOpen(true),
          },
        }}
      />
    </Wrapper>
  );
};

export default TimePickerInput;
